<form
  data-test="P-UMr_xz"
  (mouseleave)="onSearchLeave()"
  class="search-top"
  [ngClass]="classes"
  (mdOutsideClick)="onOutsideClick()"
  [class.active]="showSearchField || alwaysActive"
>
  <button
    data-test="rKNFVEoX"
    (mouseenter)="onSearchHover()"
    (click)="toggleSearchField(true)"
    class="search-top__toggle"
    type="button"
  >
    <span data-test="P2SUdVFB" class="search-top__toggle-icon">
      <svg data-test="ZvRUREen" class="icon__icon-search" width="18px" height="17.5px">
        <use xlink:href="#icon-search"></use>
      </svg>
    </span>
  </button>
  <div data-test="BdvN9shw" class="search-top__field">
    <input
      data-test="mvBy9bPg"
      class="search__input search__input_icon input input_sm input_bb input_bb-hover"
      type="text"
      [class.filled]="searchInput.value"
      [value]="searchQuery"
      [disabled]="disabled"
      #searchInput
    />
    <label data-test="6ss9e6QN" class="search-top__label">Search...</label>
    <button
      data-test="vJznOzmk"
      class="search-top__clear"
      type="button"
      *ngIf="searchInput.value.trim().length"
      (click)="clearSearch()"
    ></button>
    <button
      data-test="ytshUsnt"
      *ngIf="showFilterButton"
      class="ml-2"
      type="button"
      [class.active]="filterButtonActive"
      (click)="$event.stopPropagation(); toggleFilter.emit()"
    >
      <span data-test="y1jIpneq" class="badge badge_gray p-0">
        <i data-test="QWQdquG9" class="material-icons md-16">
          {{ filterButtonActive ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </i>
      </span>
    </button>
  </div>
</form>
